import { TableSchema } from '../metadata-schema';
import { Niveau } from '../enums/Niveau';
import { dim_br_brin } from './dim_br_brin';
import { dim_clc_cijfer_label_conversie } from './dim_clc_cijfer_label_conversie';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_lg_lesgroep } from './dim_lg_lesgroep';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { fac_or_onderwijsresultaten } from './fac_or_onderwijsresultaten';
import { dim_vk_vak } from './dim_vk_vak';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { Examenstatus } from '../enums/Examenstatus';
import { ExamenstatusMetPrognose } from '../enums/ExamenstatusMetPrognose';
import { DoorstroomResultaatMetPrognose } from '../enums/DoorstroomResultaatMetPrognose';
import { ResultaatBijzonderheid } from '../enums/ResultaatBijzonderheid';
import { EerderGeexamineerd } from '../enums/EerderGeexamineerd';
import { ExamencijfersUitzondering } from '../enums/ExamencijfersUitzondering';
import { Cijferkolomtype } from '../enums/Cijferkolomtype';
import { SoortVakpositie } from '../enums/SoortVakpositie';

export const fac_cf_cijfer: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_cf_cijfer",
	"description": "Definitie voor fact tabel fac_cf_cijfer uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"agg-tables": [
		"fac_cf_cijfer_agg_filters",
		"fac_cf_cijfer_agg_leerling"
	],
	"properties": {
		"cf_abb_adviescategorie": {
			"type": "string",
			"label": "Adviescategorie (afk)",
			"category": "Resultaat",
			"example": "Niv, Keuze, ...",
			"description": "De afkorting van de adviescategorie van dit resultaat. Alleen van toepassing voor resultaten met kolomtype Advies.",
			"blocklist": {
				"magister": true
			}
		},
		"cf_abb_kolomkop": {
			"type": "string",
			"label": "Cijferkolom kop",
			"category": "Resultaat",
			"example": "VG, r3, ...",
			"description-somtoday": "Een korte kolomkop van dit cijfer. Het verschilt per type welk gegeven uit het bronsysteem hiervoor gebruikt wordt:\n- Toets: De afkorting van de **toetssoort**. Dit is dus niet de afkorting van de toets zelf.\n- Gemiddelde: r + periodenummer.\n- Rapportcijfer: R + periodenummer.\n- Examencijfers: SE, CE1, CE2, CE3 of Eind.\n- Advies: De afkorting van de advieskolom.",
			"description-magister": "De afkorting van kolomkop van dit cijfer."
		},
		"cf_abb_label": {
			"type": "string",
			"label": "Label (afk)",
			"category": "Resultaat",
			"example": "V, ZG, ...",
			"description-somtoday": "De afkorting van het label van dit resultaat (bijvoorbeeld O, V of G). Alleen gevuld voor resultaten met een resultaatweergave anders dan Cijfer 1-10.",
			"description-magister": "De afkorting van de tekstuele beoordeling van dit resultaat (bijvoorbeeld O, V of G). Alleen gevuld voor tekstuele resultaten."
		},
		"cf_abb_onderwijssoort_vak": {
			"label": "Vak onderwijssoort",
			"category": "Vak",
			"example": "VMBO b, HAVO / VWO, ...",
			"description": "Het niveau waarop de leerling dit vak volgt en een cijfer heeft behaald. Dit kan afwijken van het niveau van de leerling zelf, bijvoorbeeld als de leerling examen doet op hoger niveau.",
			"type": "string",
			"schema": Niveau
		},
		"cf_abb_vak": {
			"type": "string",
			"label": "Vak (afk)",
			"category": "Vak",
			"example": "entl, wisA, ...",
			"description": "De afkorting van het vak waarvoor dit cijfer is behaald."
		},
		"cf_co_brin": {
			"type": "string",
			"label": "Instellingscode",
			"searchKeys": [
				"BRIN"
			],
			"category": "School",
			"example": "01XX",
			"description": "Het BRIN-nummer van de instelling waarop deze leerling is ingeschreven."
		},
		"cf_co_kolom": {
			"type": "string",
			"label": "Cijferkolom",
			"category": "Resultaat",
			"example": "netl151, T1, RepT3, SE, ...",
			"description-somtoday": "De afkorting van deze cijferkolom.",
			"description-magister": "De code van de cijferkolom. Dit is doorgaans vakafkorting + kolomnummer."
		},
		"cf_d_cijfer": {
			"type": "string",
			"format": "date",
			"label": "Datum cijfer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "De invoerdatum van het cijfer."
		},
		"cf_des_kolom": {
			"type": "string",
			"label": "Cijferkolom omschrijving",
			"category": "Resultaat",
			"example": "H1 grammatica, opdracht bij hst 7",
			"description": "De volledige naam of omschrijving van het cijfer."
		},
		"cf_fk_br_vest": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"cf_fk_clc": {
			"description": "Definitie voor dimension tabel dim_clc_cijfer_label_conversie uit de CumLaude DWH",
			"type": "object",
			"schema": dim_clc_cijfer_label_conversie
		},
		"cf_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"cf_fk_ilt_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"cf_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"cf_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"cf_fk_lb": {
			"exclude": [
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_examenstatus",
				"lb_nm_idu",
				"lb_nm_klas",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"cf_fk_lb_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"cf_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_idu",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"cf_fk_ll": {
			"exclude": [
				"ll_is_cohortstatus_tot_volledig",
				"ll_nm_leerling"
			],
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"cf_fk_lg": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
			"type": "object",
			"schema": dim_lg_lesgroep
		},
		"cf_fk_mw_mentor1": {
			"labelOverride": {
				"mw_abb_medewerker": "Eerste mentor (afkorting)",
				"mw_nm_medewerker": "Eerste mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de eerste mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de eerste mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"cf_fk_mw_mentor2": {
			"labelOverride": {
				"mw_abb_medewerker": "Tweede mentor (afkorting)",
				"mw_nm_medewerker": "Tweede mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de tweede mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de tweede mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"cf_fk_mw_mentor_indiv": {
			"labelOverride": {
				"mw_abb_medewerker": "Individuele mentor (afkorting)",
				"mw_nm_medewerker": "Individuele mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de individuele mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de individuele mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"cf_fk_or_exccl": {
			"include": [],
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"cf_fk_or_cvcl": {
			"include": [],
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"cf_fk_vk": {
			"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vk_vak
		},
		"cf_fk_vs": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"cf_fk_vs_bekostiging": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"cf_fks_mw": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
				"type": "object",
				"schema": dim_mw_medewerker
			}
		},
		"cf_fun_is_plaatsing_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Actuele plaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Voor het huidige schooljaar: Ja als dit cijfer bij een plaatsing hoort die op dit moment actief is.\nVoor schooljaren in het verleden: Ja als dit cijfer bij een plaatsing hoort die aan het einde van het schooljaar actief was."
		},
		"cf_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 april van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 april wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 augustus van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 augustus wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 december van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 december wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 februari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 februari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 januari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 januari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 juli van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juli wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 juni van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juni wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 mei van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 mei wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 maart van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 maart wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 november van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 november wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 oktober van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 oktober wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of dit cijfer bij een plaatsing hoort die actief was op 1 september van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 september wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"cf_fun_nm_examenstatus": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Examenstatus
		},
		"cf_fun_nm_examenstatus_met_prognose": {
			"label": "Examenstatus",
			"category": "Examen",
			"searchKeys": [
				"Geslaagd",
				"Afgewezen",
				"Teruggetrokken",
				"Voorlaatste jaar",
				"Gespreid examen",
				"Gezakt"
			],
			"example": "Geslaagd, Afgewezen, Voorlaatste jaar, ...",
			"description": "De uitslag van het examen of de status waarin het examen zich bevindt:\n- Geslaagd: de leerling is geslaagd of is uitgeschreven met vertrekstatus Geslaagd.\n- Afgewezen: de leerling is afgewezen (gezakt) of is uitgeschreven met vertrekstatus Afgewezen.\n- Teruggetrokken: de leerling heeft zich voor of tijdens het examen teruggetrokken en niet langer examenkandidaat.\n- Voorlaatste jaar: de leerling zit in het (voor)voorlaatste jaar van de opleiding en doet dit jaar in één of meer vakken examen.\n- Gespreid examen: de leerling zit in het eerste jaar van een gespreid examen en doet dit jaar examen in een deel van de vakken.\n\nDe aanduiding (prognose) bij Geslaagd of Afgewezen geeft aan dat er nog geen uitslag is, maar wat de uitslag zou zijn op basis van de SE-cijfers van de leerling.",
			"type": "string",
			"schema": ExamenstatusMetPrognose
		},
		"cf_fun_nm_idu": {
			"label": "Doorstroom",
			"category": "Doorstroom",
			"searchKeys": [
				"Opstroom",
				"Afstroom",
				"Doorstroom",
				"Geslaagd",
				"Afgewezen"
			],
			"example": "Doorstroom, Geslaagd, Afstroom, ...",
			"description": "Geeft aan wat het doorstroomresultaat van de plaatsing van deze leerling is:\n- Doorstroom: de leerling gaat naar een hoger leerjaar op hetzelfde niveau\n- Doublure: de leerling gaat naar hetzelfde leerjaar op hetzelfde niveau, of de leerling stroomt zonder diploma uit naar het MBO\n- Opstroom: de leerling gaat naar een hoger niveau (ongeacht leerjaar)\n- Afstroom: de leerling gaat naar een lager niveau (ongeacht leerjaar)\n- Geslaagd: de leerling is examenkandidaat en heeft examenstatus Geslaagd\n- Afgewezen: de leerling is examenkandidaat en heeft examenstatus Afgewezen; er is nog geen vervolgplaatsing\n- Geen: de leerling heeft binnen hetzelfde schooljaar een volgende plaatsing met hetzelfde leerjaar en niveau\n\nWanneer dit veld leeg is, is het doorstroomresultaat onbekend omdat het niveau en/of leerjaar van deze of de volgende plaatsing onbekend is, \nof bij een uitstromende leerling het niveau en/of leerjaar op de school van bestemming onbekend is.\nBij dashboards die 1-oktoberplaatsingen tonen, is het Doorstroomveld gebaseerd op het niveau en leerjaar van deze plaatsing ten opzichte van de volgende 1-oktoberplaatsing.\nBij dashboards die de volledige loopbaan van een leerling volgen, zoals Details > Leerling, is dit veld gebaseerd op het niveau en leerjaar van deze plaatsing ten opzichte van de volgende plaatsing, die mogelijk in hetzelfde schooljaar ligt.\nDe aanduiding (prognose) bij Geslaagd of Afgewezen geeft aan dat er nog geen uitslag is, maar wat de uitslag zou zijn op basis van de SE-cijfers van de leerling.\nBij de overige waarden geeft de aanduiding (prognose) aan dat deze is bepaald op basis van een adviesplaatsing of voorlopige plaatsing.",
			"type": "string",
			"schema": DoorstroomResultaatMetPrognose
		},
		"cf_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"cf_fun_nm_kolomgroep": {
			"type": "string",
			"label": "Toets",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_nm_leerjaar_niveau_lesgroep": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ...",
			"description-magister": "De eerste of tweede nationaliteit van deze leerling.",
			"description-somtoday": "De eerste of tweede nationaliteit van deze leerling.\nIndien in Somtoday de nationaliteit volgens het BRP is ingevuld, wordt dit \nveld gebruikt, tenzij het vinkje \"wijkt bewust af\" is ingeschakeld."
		},
		"cf_fun_nm_periode": {
			"type": "string",
			"label": "Cijferperiode",
			"category": "Resultaat",
			"example": "P1, P2, ...",
			"description": "De periode (naam of nummer) van dit cijfer."
		},
		"cf_fun_nm_schooljaar_leerfase": {
			"type": "string",
			"label": "Schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_nr_aantal_docenten": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_nr_cijferverschil_se_ce": {
			"type": "number",
			"label": "Verschil SE-CE",
			"category": "Examen",
			"example": "-2,5; 1,5",
			"description": "Als dit een SE-cijfer is: het verschil tussen het SE-cijfer en het bijbehorende (hoogste) CE-cijfer. Indien het SE-cijfer hoger is, is het verschil positief."
		},
		"cf_fun_nr_cijferverschil_se_ce_afgerond": {
			"type": "number",
			"label": "Verschil SE-CE (afgerond)",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Als dit een SE-cijfer is: het verschil tussen het SE-cijfer en het bijbehorende (hoogste) CE-cijfer, afgerond op halven. Indien het SE-cijfer hoger is, is het verschil positief."
		},
		"cf_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"cf_fun_nr_plaatsing_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van deze plaatsing met het basisschooladvies:\n- -1 als het niveau van deze plaatsing lager is dan het basisschooladvies\n- 0 als het niveau van deze plaatsing gelijk is aan het basisschooladvies\n- 0,5 als het niveau van deze plaatsing HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van deze plaatsing hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDe score voor de eerste plaatsing in leerjaar 3 wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"cf_fun_nr_plaatsing_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van deze plaatsing en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"cf_fun_nr_plaatsing_lj3_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van de eerste plaatsing in leerjaar 3 met het basisschooladvies:\n- -1 als het niveau van leerjaar 3 lager is dan het basisschooladvies\n- 0 als het niveau van leerjaar 3 gelijk is aan het basisschooladvies\n- 0,5 als het niveau van leerjaar 3 HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van leerjaar 3 hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDeze score wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"cf_fun_nr_plaatsing_lj3_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van de eerste plaatsing in leerjaar 3 van deze leerling en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"cf_fun_nr_toets_rank": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_nr_volgnr_vak": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_fun_sum_tekortpunten": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_is_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_is_alternatievenormering": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Cijferniveau",
			"category": "Resultaat",
			"example": "Ja, Nee",
			"description": "Voor toetsdossiers waarbij gebruik gemaakt wordt van een meervoudige toetsnorm:\nJa indien dit het cijfer betreft voor de alternatieve normering; Nee voor de standaard normering.",
			"blocklist": {
				"magister": true
			}
		},
		"cf_is_combinatiecijfer": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Ja als dit vak het Combinatiecijfer betreft."
		},
		"cf_is_combinatiecijfervak": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Combinatiecijfervak",
			"category": "Vak",
			"example": "Ja, Nee",
			"description": "Ja als dit vak meetelt voor het Combinatiecijfer."
		},
		"cf_is_diplomavak": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Diplomavak",
			"category": "Examen",
			"example": "Ja, Nee",
			"description": "Ja als dit vak meetelt voor het diploma en de leerling het vak niet heeft laten vallen."
		},
		"cf_is_examendossier": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "In examendossier",
			"category": "Resultaat",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als dit cijfer deel uitmaakt van het examendossier van dit vak.",
			"description-magister": "Ja als dit een examenvak is."
		},
		"cf_is_examenkandidaat": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_is_hoogste_ce": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Ja als dit CE-cijfer het hoogste is van de CE-cijfers die de leerling voor dit vak heeft behaald.\nHet hoogste CE-cijfer telt mee voor de examenuitslag."
		},
		"cf_is_hoogste_eind": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Ja als dit Eindcijfer het hoogste is van de eindcijfers die de leerling voor dit vak heeft behaald.\nHet hoogste eindcijfer telt mee voor de examenuitslag."
		},
		"cf_is_laatste_gemiddelde": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Ja als dit cijfer een rapportgemiddelde (kleine r-kolom) is van de laatste periode van dit schooljaar waarvoor\ndeze leerling een cijfer heeft voor dit vak. Bij vakken met alleen een examendossier is het SE-cijfer\nook gemarkeerd als Laatste gemiddelde.",
			"description-magister": "Ja als deze cijferkolom in Magister is gemarkeerd als Voortschrijdend gemiddelde.\nBij vakken zonder Voortschrijdend gemiddelde maar met een SE-cijfer, wordt het SE-cijfer aangemerkt als Laatste gemiddelde.\nBij vakken zonder Voortschrijdend gemiddelde en zonder SE-cijfer is de laatste cijferkolom van type gemiddelde\n(gesorteerd op periodenummer en kolomnummer) het Laatste gemiddelde."
		},
		"cf_is_laatste_rapportcijfer": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Ja als dit cijfer een Rapportcijfer (grote R-kolom) is van de laatste periode van dit schooljaar waarvoor\ndeze leerling een cijfer heeft voor dit vak."
		},
		"cf_is_laatste_periodegemiddelde": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Ja als dit cijfer een Periodegemiddelde (grote P-kolom) is van de laatste periode van dit schooljaar waarvoor\ndeze leerling een cijfer heeft voor dit vak."
		},
		"cf_is_telt_mee_voor_slagen": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Telt mee voor slagen",
			"category": "Examen",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als in de vakpositie van dit vak is ingesteld dat het vak meetelt voor de examenuitslag.",
			"description-magister": "Ja als dit een examenvak is."
		},
		"cf_is_voldoende": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Cijfer is voldoende",
			"category": "Resultaat",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als dit cijfer voldoende is. \nDat wil zeggen dat het cijfer groter is dan of gelijk aan 5,5 of het label (bijv. O/V/G) is gemarkeerd als voldoende.",
			"description-magister": "Ja als dit cijfer voldoende is. \nDat wil zeggen dat het cijfer groter is dan of gelijk aan 5,5 of de tekstuele waarde (bijv. O/V/G) is gemarkeerd als voldoende."
		},
		"cf_is_voortgangsdossier": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "In voortgangsdossier",
			"category": "Resultaat",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als dit cijfer deel uitmaakt van het voortgangsdossier van dit vak.",
			"description-magister": "Ja als dit geen examenvak is."
		},
		"cf_nm_adviescategorie": {
			"type": "string",
			"label": "Adviescategorie",
			"category": "Resultaat",
			"example": "Niveau advies, Vakkeuze advies, ...",
			"description": "De naam van de adviescategorie van dit resultaat. Alleen van toepassing voor resultaten met kolomtype Advies.",
			"blocklist": {
				"magister": true
			}
		},
		"cf_nm_bijzonderheid": {
			"label": "Bijzonderheid",
			"category": "Resultaat",
			"searchKeys": [
				"Geen",
				"Niet gemaakt",
				"Vrijstelling",
				"Telt niet mee",
				"inhaaltoets",
				"inhalen",
				"*"
			],
			"example": "Geen, Niet gemaakt, Vrijstelling, Telt niet mee",
			"description-somtoday": "Geeft aan of er een bepaalde bijzonderheid van toepassing is voor dit cijfer:\n- Geen: geen bijzonderheden.\n- Niet gemaakt: dit resultaat is gemarkeerd met een sterretje ('*') om aan te geven dat de leerling deze toets of één van de toetsen die meetellen voor dit gemiddelde (nog) niet heeft gemaakt.\n- Vrijstelling: de leerling heeft een vrijstelling ('vr') voor deze toets.\n- Telt niet mee: dit resultaat is gemarkeerd met een 'X' om aan te geven dat het niet meetelt voor deze leerling.",
			"description-magister": "Geeft aan of er een bepaalde bijzonderheid van toepassing is voor dit cijfer:\n- Geen: geen bijzonderheden.\n- Niet gemaakt: dit cijfer is gemarkeerd met 'inhalen' om aan te geven dat de leerling deze toets moet inhalen.  \n- Vrijstelling: de leerling heeft een vrijstelling voor deze toets.\n- Telt niet mee: dit cijfer telt niet mee voor deze leerling.",
			"type": "string",
			"schema": ResultaatBijzonderheid
		},
		"cf_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_nm_eerder_geexamineerd": {
			"label": "Eerder geëxamineerd",
			"category": "Examen",
			"example": "Voorlaatste jaar, Gespreid examen",
			"description": "Geeft aan of dit examencijfer in een eerder jaar is behaald dan het jaar waarin het meetelt voor het examen:\n- Voorlaatste jaar: de leerling heeft voor dit vak in zijn of haar voorlaatste jaar examen gedaan, maar het cijfer telt voor dit schooljaar mee.\n- Gespreid examen: de leerling doet gespreid examen. Het cijfer voor dit vak is vorig jaar behaald en telt voor dit schooljaar mee.",
			"type": "string",
			"schema": EerderGeexamineerd
		},
		"cf_nm_excijf_uitzondering": {
			"label": "Examencijfers uitzondering",
			"category": "Examen",
			"example": "Uitgesloten van ROD-communicatie, VAVO-opleiding, ...",
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor zijn of haar examencijfers niet meetellen voor de indicator Examencijfers:\n- Regulier examencijfer: geen uitzondering van toepassing; de examencijfers tellen mee voor de indicator.\n- Geen examencijfer: dit betreft geen SE-, CE- of eindcijfer en telt daarom niet mee voor de examencijfers.\n- Geen diplomavak: dit vak is niet gemarkeerd als diplomavak en telt daarom niet mee voor de examencijfers.\n- Assistentenopleiding/Entreeopleiding: de leerling doet de entreeopleiding van het VMBO en telt daarom niet mee voor de indicator Examencijfers.\n- VAVO-opleiding: de leerling zit op de VAVO; examencijfers behaald op deze school tellen niet mee voor de indicator Examencijfers.\n- Extraneus: de leerling was op 1 oktober van dit schooljaar ingeschreven bij een andere instelling dan waar hij of zij examen doet; de cijfers tellen niet mee voor de indicator Examencijfers.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt daarom niet mee voor de examencijfers.\n- Niet geslaagd of afgewezen: de leerling heeft geen examenuitslag en telt daarom niet mee voor de examencijfers.\n- In eerder jaar geëxamineerd van gespreid examen: de leerling doet gespreid examen; de cijfers behaald in het eerste jaar tellen niet mee voor de indicator Examencijfers.                           \n      # Vakmanschap/technologie-route is niet meegenomen omdat dit sinds 2018/2019 niet meer van toepassing is.",
			"type": "string",
			"schema": ExamencijfersUitzondering
		},
		"cf_nm_klas": {
			"type": "string",
			"label": "Klas",
			"category": "Opleiding",
			"example": "1V2, 2B3, 3H4, ...",
			"description": "De klas van deze leerling."
		},
		"cf_nm_kolomtype": {
			"label": "Cijfertype",
			"category": "Resultaat",
			"searchKeys": [
				"SE cijfer",
				"CE cijfer",
				"SE-cijfer",
				"CE-cijfer",
				"gemiddelde"
			],
			"example": "Gemiddelde, SE-cijfer, Toets, ...",
			"filter": false,
			"grouping": true,
			"exportable": true,
			"description-somtoday": "Het type resultaatkolom van dit cijfer:\n- Toets: een reguliere toets, samengestelde toets, rapporttoets of werkstukcijfer.\n- Gemiddelde: het rapportgemiddelde (kleine r-kolom) van één van de periodes.\n- Rapportcijfer: het rapportcijfer (grote R-kolom) van één van de periodes.\n- SE-cijfer: het schoolexamencijfer van dit vak.\nIn voorexamenjaren (3 VMBO, 4 HAVO, 4/5 VWO) geldt dat het SE-cijfer in het huidige schooljaar de actuele stand is van het SE-cijfer voor dit vak; \nin historische schooljaren berekent CumLaude het SE-cijfer van zo'n voorexamenjaar op basis van de toetscijfers in het examendossier tot en met het betreffende leerjaar.  \n- CE-cijfer: het CE-cijfer (centraal examen) van dit vak. Als een leerling herexamen doet, zijn er meerdere CE-cijfers beschikbaar (kolom CE1, CE2 en/of CE3), waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op CE-cijfer.\n- Eindcijfer: het eindcijfer van dit vak. Als een leerling herexamen doet, zijn er meerdere eindcijfers beschikbaar, waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op Eindcijfer.\n- Advies: dit betreft een advies dat een docent kan geven over bijvoorbeeld een vakkeuze of vervolgplaatsing.",
			"description-magister": "Het type cijferkolom:\n- Toets: een reguliere toets, of een formule.\n- Gemiddelde: een gemiddelde van andere cijfers.\n- SE-cijfer: de cijferkolom die is aangewezen als het schoolexamencijfer van dit vak voor deze studie.\n- CE-cijfer: de cijferkolom die is aangewezen als CE-cijfer (centraal examen) van dit vak voor deze studie. Als een leerling herexamen doet, zijn er meerdere CE-cijfers beschikbaar (CE1, CE2 en/of CE3), waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op CE-cijfer.\n- Eindcijfer: de cijferkolom die is aangewezen als eindcijfer van dit vak. Als een leerling herexamen doet, zijn er meerdere eindcijfers beschikbaar, waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op Eindcijfer.",
			"type": "string",
			"schema": Cijferkolomtype
		},
		"cf_nm_label": {
			"type": "string",
			"label": "Label",
			"category": "Resultaat",
			"example": "Voldoende, Zeer goed, ...",
			"description-somtoday": "Het volledige label van dit resultaat (bijvoorbeeld Onvoldoende, Voldoende of Goed). Alleen gevuld voor resultaten met een resultaatweergave anders dan Cijfer 1-10.",
			"description-magister": "De volledige tekstuele beoordeling van dit resultaat (bijvoorbeeld Onvoldoende, Voldoende of Goed). Alleen gevuld voor tekstuele resultaten."
		},
		"cf_nm_leerling": {
			"type": "string",
			"label": "Leerling",
			"category": "Leerling",
			"example": "Vries, Lucas de (123456); Jong, Julia de (23456); ...",
			"description": "De achternaam, roepnaam, eventueel voorvoegsel en het leerlingnummer tussen haakjes.",
			"blocklist": {
				"bestuur": true
			}
		},
		"cf_nm_lesgroep": {
			"type": "string",
			"label": "Lesgroep",
			"category": "Vak",
			"example": "1een, h5cnetl, ...",
			"description": "De naam van de lesgroep waar de leerling in zit voor het betreffende vak. Leerlingen die overstappen naar een andere lesgroep nemen hun cijfers mee naar de nieuwe lesgroep."
		},
		"cf_nm_lesgroep_docenten": {
			"type": "string",
			"label": "Lesgroep/docenten",
			"category": "Vak",
			"example": "1een - JSL, h5cnetl - DKE, ...",
			"description": "De naam van de lesgroep waar de leerling in zit voor het betreffende vak, aangevuld met de afkorting van de bij die lesgroep behorende docent(en). Leerlingen die overstappen naar een andere lesgroep nemen hun cijfers mee naar de nieuwe lesgroep.",
			"blocklist": {
				"bestuur": true
			}
		},
		"cf_nm_lichting": {
			"type": "string",
			"label": "Lichting",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_nm_lichting_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_nm_normering": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"cf_nm_opleiding": {
			"type": "string",
			"label": "Opleiding",
			"category": "Opleiding",
			"example": "Brugklas, HAVO 3, VWO NT & NG, ...",
			"description-somtoday": "De naam van de opleiding zoals ingericht in Somtoday.",
			"description-magister": "De naam van de studie zoals ingericht in Magister."
		},
		"cf_nm_periode": {
			"type": "string",
			"label": "Cijferperiode omschrijving",
			"category": "Resultaat",
			"example": "P1, P2, ...",
			"description": "De naam van de cijferperiode van dit cijfer."
		},
		"cf_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Resultaat",
			"filter": false,
			"grouping": false,
			"example": "2022/2023",
			"description": "Het schooljaar waarin dit cijfer is behaald.\nBij examencijfers die in het geval van een examen in het voorlaatste jaar of een gespreid examen\neerder zijn geëxamineerd, is dit veld het schooljaar waarin het cijfer meetelt."
		},
		"cf_nm_soort_vakpositie": {
			"label": "Soort vakpositie",
			"category": "Vak",
			"searchKeys": [
				"Gemeenschappelijk",
				"profielvak",
				"keuzevak"
			],
			"example": "Gemeenschappelijk, Profielvak, Keuzevak, ...",
			"description-somtoday": "De vaksoort of het examendeel dat aangeeft welke rol dit vak speelt in het vakkenpakket van de leerling:\n- Gemeenschappelijk: dit is een gemeenschappelijk vak dat alle leerlingen volgen, zoals Nederlands of Engels.\n- Profielvak: dit is één van de profielvakken of profielkeuzevakken van het profiel dat de leerling gekozen heeft.\n- Keuzevak: dit is een (verplicht of optioneel) keuzevak binnen de opleiding.\n- Profielvak ster: dit is het beroepsgericht profielvak dat onderdeel is van het combinatievak.\n- Keuzevak ster: dit is een keuzevak dat onderdeel is van het combinatievak.\n- Profielmodule: dit is een module die onderdeel uitmaakt van het profielvak in het VMBO.\n- Beroepsgericht programma: dit is het beroepsgerichte programma in het VMBO.\n- Bijlage: dit cijfer betreft het examen rekenen, dat niet meetelt voor de examenuitslag en op een bijlage bij de cijferlijst staat.\n      # Sectorvak wordt niet meer gebruikt",
			"description-magister": "De vakstatus of examendeel dat aangeeft welke rol dit vak speelt in het vakkenpakket van de leerling:\n- Gemeenschappelijk: dit is een gemeenschappelijk vak dat alle leerlingen volgen, zoals Nederlands of Engels.\n- Profielvak: dit is één van de profielvakken of profielkeuzevakken van het profiel dat de leerling gekozen heeft.\n- Keuzevak: dit is een (verplicht of optioneel) keuzevak binnen de opleiding.\n- Bijlage: dit cijfer betreft het examen rekenen, dat niet meetelt voor de examenuitslag en op een bijlage bij de cijferlijst staat.",
			"type": "string",
			"schema": SoortVakpositie
		},
		"cf_nm_vak": {
			"type": "string",
			"label": "Vak",
			"category": "Vak",
			"example": "Engelse taal en literatuur, wiskunde A, ...",
			"description": "De volledige naam van dit vak."
		},
		"cf_nm_vak_uni": {
			"type": "string",
			"label": "Vak (uniform)",
			"category": "Vak",
			"example": "Engels, wiskunde, ...",
			"description": "De vereenvoudigde naam van dit vak. Verschillende varianten van dit vak hebben dezelfde uniforme naam gekregen,\nzodat cijfers voor \"hetzelfde\" vak over verschillende jaren heen kunnen worden vergeleken voor een leerling, ongeacht\nwelke variant van dit vak van toepassing is voor de leerling. Voorbeelden van varianten met dezelfde uniforme naam zijn:\n- Nederlands omvat de vakken Nederlands, Nederlandse taal en \"Nederlandse taal en literatuur\".\n- wiskunde omvat de vakken wiskunde en wiskunde A t/m D.\n- geschiedenis omvat de vakken geschiedenis en \"geschiedenis en staatsinrichting\" en \"geschiedenis en maatschappijleer\".\n- bouwtechniek omvat de vakken \"bouwtechniek - infra\", \"bouwtechniek - metselen\", \"bouwtechniek - timmeren\" en \"bouwtechiek - schilderen/afwerkingstechnieken\".\nDeze uniforme naam is bepaald op grond van de officiële landelijke vakcode van dit vak. Bij schooleigen vakken wordt de gewone vaknaam gebruikt als uniforme naam."
		},
		"cf_nm_vestiging": {
			"type": "string",
			"label": "Vestiging",
			"category": "School",
			"example": "Locatie CumLaude",
			"description": "De vestiging waar deze leerling geplaatst is."
		},
		"cf_nr_aantal_toetsen": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het aantal toetsen waar dit gemiddelde over berekend is. CumLaude bepaalt dit aantal door het aantal cijfers te tellen dat de leerling heeft behaald voor toetsen die meetellen in dit gemiddelde."
		},
		"cf_nr_cijfer": {
			"type": "number",
			"label": "Cijfer",
			"category": "Resultaat",
			"example": "1,0 - 10,0",
			"description": "Het onafgeronde cijfer. Als dit een tekstueel resultaat betreft (bijvoorbeeld O, V of G) is dit de achterliggende rekenwaarde dat is ingesteld in het bronsysteem."
		},
		"cf_nr_cijfer_afgerond": {
			"type": "integer",
			"label": "Cijfer (afgerond)",
			"category": "Resultaat",
			"example": "1 - 10",
			"description": "Het op 0 decimalen afgeronde cijfer. Als dit een tekstueel resultaat betreft (bijvoorbeeld O, V of G) is dit de achterliggende rekenwaarde dat is ingesteld in het bronsysteem."
		},
		"cf_nr_cijfer_ce": {
			"type": "number",
			"label": "Bijbehorend CE-cijfer",
			"category": "Examen",
			"filter": false,
			"grouping": false,
			"example": "1,0 - 10,0",
			"description": "Als dit cijfer een SE-cijfer is: het (hoogste, dus geldende) CE-cijfer dat de leerling voor dit vak heeft behaald.\nDoor te filteren op SE-cijfers en de velden \"Cijfer\", \"Bijbehorend CE-cijfer\" en \"Bijbehorend eindcijfer\" te exporteren,\nkun je een cijferlijst exporteren van SE-, CE- en eindcijfers zonder een draaitabel te hoeven maken."
		},
		"cf_nr_cijfer_eind": {
			"type": "number",
			"label": "Bijbehorend eindcijfer",
			"category": "Examen",
			"filter": false,
			"grouping": false,
			"example": "1,0 - 10,0",
			"description": "Als dit cijfer een SE-cijfer is: het (hoogste, dus geldende) eindcijfer dat de leerling voor dit vak heeft behaald.\nDoor te filteren op SE-cijfers en de velden \"Cijfer\", \"Bijbehorend CE-cijfer\" en \"Bijbehorend eindcijfer\" te exporteren,\nkun je een cijferlijst exporteren van SE-, CE- en eindcijfers zonder een draaitabel te hoeven maken."
		},
		"cf_nr_cijfer_vorig_sj": {
			"type": "number",
			"label": "Cijfer vorig jaar",
			"category": "Resultaat",
			"example": "1,0 - 10,0",
			"description-somtoday": "Het cijfer dat deze leerling vorig jaar heeft gehaald voor dit vak.\nHet gaat om het laatste rapportgemiddelde (kleine r-kolom) voor het vak met dezelfde uniforme naam (zie het veld \"Vak (uniform)\").",
			"description": "Het cijfer dat deze leerling vorig jaar heeft gehaald voor dit vak.\nHet gaat om het \"Laatste gemiddelde\", dus de kolom die als Voortschrijdend gemiddelde is aangemerkt of anders de laatste kolom van type Gemiddelde (gesorteerd op periode en kolomnummer).\nHierbij wordt het vak met dezelfde uniforme naam gekozen (zie het veld \"Vak (uniform)\")."
		},
		"cf_nr_decimalen": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het aantal decimalen waarmee dit cijfer moet worden weergegeven, zoals ingesteld in het bronsysteem."
		},
		"cf_nr_gem_cijfer_andere_vakken": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het gemiddelde van de cijfers van hetzelfde kolomtype dat de leerling dit schooljaar heeft behaald voor alle vakken behalve dit vak."
		},
		"cf_nr_kolom": {
			"type": "string",
			"label": "Cijferkolom volgnummer",
			"category": "Resultaat",
			"example": "321, 1, 55, ...",
			"description": "Het volgnummer van deze cijferkolom zoals ingericht in het toetsdossier van dit vak."
		},
		"cf_nr_leerjaar": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar",
			"category": "Opleiding",
			"example": "1, 2, 3, 4, 5, 6",
			"description": "Het leerjaar waarin deze leerling geplaatst is."
		},
		"cf_nr_leerjaar_vak": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Vak leerjaar",
			"category": "Vak",
			"example": "1, 2, 3, 4, 5, 6",
			"description": "Het leerjaar waarin de leerling dit vak volgt en een cijfer heeft behaald. Dit kan afwijken van het leerjaar van de leerling zelf, bijvoorbeeld als de leerling examen doet op hoger niveau of in het voorlaatste jaar."
		},
		"cf_nr_leerling": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"cf_nr_periode": {
			"type": "integer",
			"label": "Cijferperiode volgnummer",
			"category": "Resultaat",
			"example": "1, 2, ...",
			"description": "De numerieke waarde van de periode van dit cijfer."
		},
		"cf_nr_sectiegemiddelde": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het gemiddelde cijfer van alle leerlingen voor dit vak op hetzelfde niveau, leerjaar en vestiging."
		},
		"cf_nr_tekortpunten": {
			"type": "integer",
			"label": "Tekortpunten",
			"category": "Resultaat",
			"filter": false,
			"grouping": false,
			"example": "0, 1, 2, ...",
			"description": "Het aantal tekortpunten dat dit cijfer bijdraagt. Dit is 6 minus het afgeronde cijfer.\nN.B.: dit is niet het totale aantal tekortpunten van deze leerling over alle vakken heen."
		},
		"cf_nr_volgnr": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het volgnummer van deze cijferkolom binnen het toetsdossier."
		},
		"cf_nr_volgnr_vak": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Het volgnummer van dit vak binnen alle vakken van de leerling, gebaseerd op vakposities en vakcode. Alleen bedoeld om op te sorteren.",
			"description-magister": "Het volgnummer van dit studie-vak."
		},
		"cf_nr_weging": {
			"type": "integer",
			"label": "Weging",
			"category": "Toets",
			"example": "1, 2, ...",
			"description": "De weging van deze toets. Als CumLaude gemiddelden berekend over toetscijfers, wordt deze weging gebruikt, tenzij alle toetsen wegingn 0 hebben.\nAlleen cijfers van type Toets hebben een weging."
		},
		"x_cijfertype": {
			"label": "Cijfertype",
			"category": "Resultaat",
			"searchKeys": [
				"SE cijfer",
				"CE cijfer",
				"SE-cijfer",
				"CE-cijfer",
				"gemiddelde"
			],
			"example": "Laatste gemiddelde, SE-cijfer, Toets, ...",
			"filter": true,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Het type resultaatkolom van dit cijfer:\n- Toets: een reguliere toets, samengestelde toets, rapporttoets of werkstukcijfer.\n- Gemiddelde: het rapportgemiddelde (kleine r-kolom) van één van de periodes.\n- Laatste gemiddelde: het rapportgemiddelde (kleine r-kolom) van de laatste periode van dit schooljaar waarvoor deze leerlng een cijfer heeft voor dit vak, of, bij vakken met alleen een examendossier, het SE-cijfer.\n- Rapportcijfer: het rapportcijfer (grote R-kolom) van één van de periodes.\n- Laatste rapportcijfer: het rapportcijfer (grote R-kolom) van de laatste periode van dit schooljaar waarvoor deze leerling een cijfer heeft voor dit vak.\n- SE-cijfer: het schoolexamencijfer van dit vak.\nIn voorexamenjaren (3 VMBO, 4 HAVO, 4/5 VWO) geldt dat het SE-cijfer in het huidige schooljaar de actuele stand is van het SE-cijfer voor dit vak; \nin historische schooljaren berekent CumLaude het SE-cijfer van zo'n voorexamenjaar op basis van de toetscijfers in het examendossier tot en met het betreffende leerjaar.\n- CE-cijfer: het CE-cijfer (centraal examen) van dit vak. Als een leerling herexamen doet, wordt het hoogste CE-cijfer getoond.\n- Eindcijfer: het eindcijfer van dit vak. Als een leerling herexamen doet, wordt het hoogste eindcijfers getoond.\n- Advies: dit betreft een advies dat een docent kan geven over bijvoorbeeld een vakkeuze of vervolgplaatsing.",
			"description-magister": "Het type cijferkolom:\n- Toets: een reguliere toets, of een formule.\n- Gemiddelde: een gemiddelde van andere cijfers.\n- Laatste gemiddelde: het cijfer dat is gemarkeerd als Voortschrijdend gemiddelde, of, bij vakken zonder Voortschrijdend gemiddelde, het SE-cijfer of het cijfer voor de laatste gemiddeldekolom (gesorteerd op periode en kolomnummer).\n- SE-cijfer: de cijferkolom die is aangewezen als het schoolexamencijfer van dit vak voor deze studie.\n- CE-cijfer: de cijferkolom die is aangewezen als CE-cijfer (centraal examen) van dit vak voor deze studie. Als een leerling herexamen doet, zijn er meerdere CE-cijfers beschikbaar (CE1, CE2 en/of CE3), waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op CE-cijfer.\n- Eindcijfer: de cijferkolom die is aangewezen als eindcijfer van dit vak. Als een leerling herexamen doet, zijn er meerdere eindcijfers beschikbaar, waarvan het hoogste geldt. Dit is het cijfer dat je krijgt als je filtert op Eindcijfer.",
			"type": "string",
			"schema": Cijferkolomtype
		}
	}
};
